import React, { useState } from 'react';
import { Box, TextField, IconButton, Tooltip } from '@mui/material';
import { Mic as MicIcon, Stop as StopIcon } from '@mui/icons-material';
import useDictation from '../../../hooks/useDictation';

/**
 * Общий комментарий foreman'а при подписи (не привязан к материалам).
 * Отдельная секция — поле + надиктовка. Контролируемая: comment / onCommentChange.
 */
export default function SignForemanCommentSection({ comment, onCommentChange }) {
    const {
        isSupported: dictationSupported,
        isListening,
        start: startDictation,
        stop: stopDictation,
    } = useDictation({
        lang: 'en-US',
        interimResults: false,
        continuous: false,
        safetyTimeoutMs: 15000,
        prime: true,
    });
    const [listening, setListening] = useState(false);

    const toggleDictation = async () => {
        if (!dictationSupported) return;
        if (isListening) { stopDictation(); return; }
        setListening(true);
        await startDictation({
            onResult: (transcript) => {
                const cur = comment || '';
                const space = cur && !cur.endsWith(' ') ? ' ' : '';
                onCommentChange(cur + space + transcript);
            },
            onEnd: () => setListening(false),
            onError: () => setListening(false),
        });
    };

    const active = isListening && listening;

    return (
        <Box sx={{ position: 'relative' }}>
            <TextField
                fullWidth
                multiline
                minRows={1}
                maxRows={3}
                size="small"
                placeholder="General note about this week / crew…"
                value={comment || ''}
                onChange={(e) => onCommentChange(e.target.value)}
                InputProps={{ sx: { pr: 5 } }}
            />
            {dictationSupported && (
                <Tooltip title={active ? 'Stop dictation' : 'Dictate'}>
                    <IconButton
                        onClick={toggleDictation}
                        size="small"
                        sx={{
                            position: 'absolute', right: 4, top: 4,
                            bgcolor: active ? 'error.main' : 'primary.main',
                            color: '#fff',
                            '&:hover': { bgcolor: active ? 'error.dark' : 'primary.dark' },
                        }}
                    >
                        {active ? <StopIcon fontSize="small" /> : <MicIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
}
